export default __webpack_public_path__ + "static/media/pizza_icon.61de8c15.png";